export default "__VITE_ASSET__0QMXMn54__"